// Static metadata not present in pokemonData.js.
// Used by the filter engine for is:legendary, is:mythical, is:baby, is:starter,
// is:restricted, is:mega, is:gmax, and in:champ.

export const LEGENDARY_IDS = new Set([
  // Gen 1
  144, 145, 146, 150,
  // Gen 2
  243, 244, 245, 249, 250,
  // Gen 3
  377, 378, 379, 380, 381, 382, 383, 384,
  // Gen 4
  480, 481, 482, 483, 484, 485, 486, 487, 488,
  // Gen 5
  638, 639, 640, 641, 642, 643, 644, 645, 646,
  // Gen 6
  716, 717, 718,
  // Gen 7
  772, 773, 785, 786, 787, 788, 789, 790, 791, 792, 800,
  // Gen 8
  888, 889, 890, 891, 892, 894, 895, 896, 897, 898,
  905, // Enamorus
  // Gen 9
  1001, 1002, 1003, 1004, 1007, 1008,
  1014, 1015, 1016, // Okidogi, Munkidori, Fezandipiti (The Loyal Three — sub-legendary, not mythical)
  1017, // Ogerpon
  1020, 1021, 1022, 1023, // Gouging Fire, Raging Bolt, Iron Boulder, Iron Crown (Paradox)
  1024, // Terapagos
]);

export const MYTHICAL_IDS = new Set([
  // Gen 1
  151,
  // Gen 2
  251,
  // Gen 3
  385, 386,
  // Gen 4
  489, 490, 491, 492, 493,
  // Gen 5
  494, 647, 648, 649,
  // Gen 6
  719, 720, 721,
  // Gen 7
  801, 802, 807, 808, 809,
  // Gen 8
  893,
  // Gen 9
  1025, // Pecharunt
]);

export const BABY_IDS = new Set([
  172, // Pichu
  173, // Cleffa
  174, // Igglybuff
  175, // Togepi
  236, // Tyrogue
  238, // Smoochum
  239, // Elekid
  240, // Magby
  298, // Azurill
  360, // Wynaut
  406, // Budew
  433, // Chingling
  438, // Bonsly
  439, // Mime Jr.
  440, // Happiny
  446, // Munchlax
  447, // Riolu
  458, // Mantyke
]);

export const STARTER_IDS = new Set([
  // Gen 1
  1, 4, 7,
  // Gen 2
  152, 155, 158,
  // Gen 3
  252, 255, 258,
  // Gen 4
  387, 390, 393,
  // Gen 5
  495, 498, 501,
  // Gen 6
  650, 653, 656,
  // Gen 7
  722, 725, 728,
  // Gen 8
  810, 813, 816,
  // Gen 9
  906, 909, 912,
]);

// VGC restricted Pokémon — the box legendaries allowed 1-per-team in restricted formats.
// Includes all battle-relevant alternate forms.
export const RESTRICTED_IDS = new Set([
  // Mewtwo
  150,
  // Lugia / Ho-Oh
  249, 250,
  // Kyogre, Groudon, Rayquaza + primals
  382, 10077, // Kyogre + Primal
  383, 10078, // Groudon + Primal
  384,        // Rayquaza
  // Dialga, Palkia, Giratina + origin forms
  483, 10245, // Dialga + Origin
  484, 10246, // Palkia + Origin
  487, 10007, // Giratina-Altered + Origin
  // Reshiram, Zekrom, Kyurem + fusions
  643, 644,
  646, 10022, 10023, // Kyurem + Black + White
  // Xerneas, Yveltal, Zygarde + forms
  716, 717,
  718, 10118, 10119, 10120, 10181, // Zygarde forms
  // Solgaleo, Lunala, Necrozma + fusions
  791, 792,
  800, 10155, 10156, 10157, // Necrozma + Dusk Mane + Dawn Wings + Ultra
  // Zacian, Zamazenta, Eternatus + crowned forms
  888, 10188, // Zacian + Crowned
  889, 10189, // Zamazenta + Crowned
  890,        // Eternatus (Eternamax is not a catchable battle form)
  // Calyrex + rider forms
  898, 10193, 10194, // Calyrex + Ice Rider + Shadow Rider
  // Koraidon, Miraidon (riding builds are cosmetic, not included)
  1007, 1008,
  // Terapagos + forms
  1024, 10276, 10277,
]);

// Base species IDs confirmed available in Pokémon Champions.
// Source: https://www.serebii.net/pokemonchampions/pokemon.shtml
// The filter engine resolves mega and alternate form IDs back to these base IDs,
// so only base dex numbers are needed here.
export const CHAMPIONS_IDS = new Set([
  // Gen 1
  3, 6, 9, 15, 18, 24, 25, 26, 36, 38, 59, 65, 68, 71, 80, 94,
  115, 121, 127, 128, 130, 132, 134, 135, 136, 142, 143, 149,
  // Gen 2
  154, 157, 160, 168, 181, 184, 186, 196, 197, 199, 205, 208,
  212, 214, 227, 229, 248,
  // Gen 3
  279, 282, 302, 306, 308, 310, 319, 323, 324, 334, 350, 351,
  354, 358, 359, 362,
  // Gen 4
  389, 392, 395, 405, 407, 409, 411, 428, 442, 445, 448, 450,
  454, 460, 461, 464, 470, 471, 472, 473, 475, 478, 479,
  // Gen 5
  497, 500, 503, 505, 510, 512, 514, 516, 530, 531, 534, 547,
  553, 563, 569, 571, 579, 584, 587, 609, 614, 618, 623, 635, 637,
  // Gen 6
  652, 655, 658, 660, 663, 666, 670, 671, 675, 676, 678, 681,
  683, 685, 693, 695, 697, 699, 700, 701, 702, 706, 707, 709,
  711, 713, 715,
  // Gen 7
  724, 727, 730, 733, 740, 745, 748, 750, 752, 758, 763, 765,
  766, 778, 780, 784,
  // Gen 8
  823, 841, 842, 844, 855, 858, 866, 867, 869, 877, 887, 899,
  900, 902, 903,
  // Gen 9
  908, 911, 914, 925, 934, 936, 937, 939, 952, 956, 959, 964,
  968, 970, 981, 983, 1013, 1018, 1019,
]);
